import { Component, Input } from '@angular/core';
import { LsqApiServiceListSource } from '@lsq-frontend/angular-shared/api-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import {
    DENIED_INVOICES_DESCRIPTION,
    FEE_DESCRIPTION,
    INELIGIBLES_PURCHASES_DESCRIPTION
} from '../../../../../../constants/copy.constants';
import {
    GetPurchasesRequest,
    GetPurchasesResponse,
    Purchase
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';

@Component({
    selector: 'purchases-by-customer-grouped-table-header',
    template: `
        <lsq-data-table
            [dataSource]="dataSource"
            [isHeaderOnly]="true"
            [layoutFixed]="true"
            [hasStickyHeader]="true"
        >
            <lsq-hidden-column width="4.7rem"></lsq-hidden-column>

            <lsq-hidden-column
                width="4.8rem"
                [column]="{ key: 'spacer-hidden' }"
            ></lsq-hidden-column>

            <lsq-hidden-column width="3%" [column]="{ key: 'counter-hidden' }"></lsq-hidden-column>

            <lsq-column
                [column]="{
                    header: invoiceNumberHeader,
                    key: 'invoiceNumber',
                    width: '17%',
                    sortable: false
                }"
            >
            </lsq-column>

            <lsq-date-column
                [column]="{
                    header: invoiceDateHeader,
                    className: 'invoice-date-col',
                    key: 'invoiceDate',
                    width: '5%',
                    sortable: false
                }"
            >
            </lsq-date-column>

            <lsq-currency-column
                [column]="{
                    header: amountHeader,
                    className: 'purchase-amount-col',
                    key: 'invoiceAmount',
                    width: '13%',
                    sortable: false
                }"
            >
            </lsq-currency-column>

            <lsq-currency-column
                [column]="{
                    header: deniedHeader,
                    className: 'denied-amount-col',
                    key: 'deniedAmount',
                    width: '13%',
                    sortable: false,
                    headerPopoverContent: deniedPopoverContent
                }"
            >
            </lsq-currency-column>

            <lsq-currency-column
                [column]="{
                    header: ineligiblesHeader,
                    className: 'ineligibles-amount-col',
                    key: 'ineligibleAmount',
                    width: '13%',
                    sortable: false,
                    headerPopoverContent: ineligiblesPopoverContent
                }"
            >
            </lsq-currency-column>

            <lsq-currency-column
                [column]="{
                    header: feesHeader,
                    key: 'feesIncurred',
                    className: 'fees-col',
                    width: '13%',
                    sortable: false,
                    headerPopoverContent: feesPopoverContent
                }"
            >
            </lsq-currency-column>

            <lsq-column
                [column]="{
                    key: 'statusDot',
                    width: '6%',
                    sortable: false
                }"
            >
            </lsq-column>

            <lsq-column
                [column]="{
                    header: statusHeader,
                    key: 'status',
                    className: 'popover-pad',
                    width: '9rem',
                    sortable: false
                }"
            >
            </lsq-column>
        </lsq-data-table>
    `
})
export class PurchasesByCustomerGroupedTableHeaderComponent {
    @Input() public dataSource: LsqApiServiceListSource<
        GetPurchasesResponse,
        GetPurchasesRequest,
        Purchase[]
    >;

    public deniedPopoverContent = DENIED_INVOICES_DESCRIPTION;
    public ineligiblesPopoverContent = INELIGIBLES_PURCHASES_DESCRIPTION;
    public feesPopoverContent = FEE_DESCRIPTION;

    public customersHeader = this._i18n({
        value: 'Customer',
        meaning: 'Customer header for purchases by customer table'
    });
    public invoiceNumberHeader = this._i18n({
        value: 'Invoice #',
        meaning: 'Invoice # header for purchases by customer table'
    });
    public invoiceDateHeader = this._i18n({
        value: 'Invoice<br/>Date',
        meaning: 'Invoice date header for purchases by customer table'
    });
    public amountHeader = this._i18n({
        value: 'Amount',
        meaning: 'Amount header for purchases by customer table'
    });
    public deniedHeader = this._i18n({
        value: 'Denied',
        meaning: 'Denied header for purchases by customer table'
    });
    public ineligiblesHeader = this._i18n({
        value: 'Ineligibles',
        meaning: 'Ineligibles header for purchases by customer table'
    });
    public feesHeader = this._i18n({
        value: 'Fees',
        meaning: 'Fees header for purchases by customer table'
    });
    public statusHeader = this._i18n({
        value: 'Status',
        meaning: 'Status Funds header for purchases by customer table'
    });

    constructor(private _i18n: I18n) {}
}
